module.exports = __webpack_public_path__ + "static/image_7-029e3edb125e0dd6694567515b3876ef.jpg";